<template>
    <div class="header grid">
        <cmp-header-teaser v-if="headerTeaser" :container="headerTeaser"></cmp-header-teaser>

        <div class="header--desktop" v-if="!hasBurgerMenu">
            <cmp-meta-nav v-if="meta" :container="meta"></cmp-meta-nav>
            <cmp-main-nav v-if="menu" :structure="menu"></cmp-main-nav>
        </div>
        <div class="header--mobile" v-if="hasBurgerMenu">
            <cmp-mobile-nav></cmp-mobile-nav>
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';


    export default {
        props: {
            meta: Object,
            main: Object,
            headerTeaser: Object,
        },
        computed: {
            ...mapGetters(['viewport']),
            hasBurgerMenu() {
                return toNumeral(this.viewport.mq.query) <= numerals.MD;
            },
            menu() {
                return get(this.main, 'content.menu');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?4c354dd6